import React from 'react';
import './MScInAccountingAndFinance.css'; // Optional: Create a CSS file for styling

const BAInEDPM = () => {
  return (
    <div className="msc-container" style={{ padding: '20px', maxWidth: '800px', marginTop: '190px',marginLeft:'70' }}>
      <h1 style={{ textAlign: 'center' }}>
        📘 Bachelor of Arts in Educational Planning and Management (EDPM)
      </h1>

      <section>
        <h2 style={{ textAlign: 'center' }}>Program Overview</h2>
        <p>
          The BA in Educational Planning and Management at Admas University prepares students to become effective education leaders and administrators. This program provides foundational knowledge in educational systems, policy analysis, school leadership, and management, empowering graduates to support and improve education delivery in Ethiopia and beyond.
        </p>
      </section>

      <section>
        <h2>🎓 Program Objectives</h2>
        <ul>
          <li>To equip students with knowledge and skills in planning and managing educational institutions.</li>
          <li>To provide a strong foundation in educational leadership, supervision, and administration.</li>
          <li>To enable students to assess and evaluate educational policies and practices.</li>
          <li>To promote research and innovation in the field of educational development.</li>
        </ul>
      </section>

      <section>
        <h2>📚 Key Courses</h2>
        <ul>
          <li>Introduction to Educational Planning</li>
          <li>School Leadership and Supervision</li>
          <li>Education Policy and Reform</li>
          <li>Educational Psychology</li>
          <li>Principles of Management in Education</li>
          <li>Monitoring and Evaluation in Education</li>
          <li>Curriculum Studies</li>
          <li>Research Methods in Education</li>
          <li>Educational Statistics</li>
          <li>Senior Research Project</li>
        </ul>
      </section>

      <section>
        <h2>🎓 Admission Requirements</h2>
        <ul>
          <li>Completion of preparatory education (Grade 12) and passing the Ethiopian university entrance exam.</li>
          <li>Diploma graduates with relevant qualifications may join through the advanced standing program.</li>
        </ul>
      </section>

      <section>
        <h2>🧭 Career Opportunities</h2>
        <p>
          Graduates can work as school administrators, educational supervisors, planners, policy analysts, or continue to postgraduate studies. They may find employment in schools, regional education bureaus, NGOs, and educational research centers.
        </p>
      </section>

      <section>
        <h2>🏛️ Why Study EDPM at Admas University?</h2>
        <ul>
          <li>Accredited and nationally recognized undergraduate program.</li>
          <li>Expert faculty with field experience in education leadership and management.</li>
          <li>Access to modern libraries, e-learning platforms, and student support services.</li>
          <li>Campuses and distance education centers across the country for flexible learning.</li>
        </ul>
      </section>
    </div>
  );
};

export default BAInEDPM;